exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stamp-overLay .no-presets{color:var(--no-presets-text);display:flex;justify-content:center;align-items:center;width:100%}", ""]);

// exports
